import services from '../config/services'

// The version set in FB.init() should overwrite the script version
window.fbAsyncInit = () =>
  FB.init({
    appId: services.FACEBOOK_KEY,
    status: false,
    cookie: true,
    xfbml: true,
    version: '2.7',
  })

const init = () => {
  /* eslint-disable */
  // intialize facebook tracking
  if (window.TBT.disable.indexOf('facebook') === -1) {
    ;(function(d, debug) {
      var js,
        id = 'facebook-jssdk',
        ref = d.getElementsByTagName('script')[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement('script')
      js.id = id
      js.async = true
      js.src = '//connect.facebook.net/en_US/all' + (debug ? '/debug' : '') + '.js'
      ref.parentNode.insertBefore(js, ref)
    })(document, false)
  }
  /* eslint-enable */
}

// eslint-disable-next-line import/prefer-default-export
export const pageLoaded = init
